import { useCallback } from "react";

export const useUploadFileBySignedUrl = () => {
    const uploadImageBySignedUrl = useCallback(
        async (
            file: File,
            fields: Record<string, string>,
            signedUrl: string
        ) => {
            const formData = new FormData();
            Object.entries(fields).map(([key, value]) => {
                formData.append(key, value);
            });
            formData.append("file", file);

            // 署名済みURLでアップロード
            const response = await fetch(signedUrl, {
                method: "POST",
                body: formData,
            });
            if (!response.ok) {
                throw new Error("Failed to upload image");
            }
        },
        []
    );

    return uploadImageBySignedUrl;
};
